import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const type = "PROGRAMS";

export const globoProgramsAPI = createStaticResourceAPI({
  baseURL: `${process.env.REACT_APP_GLOBO_API}/staticdata/programs`,
  resource: "GloboPrograms",
  idKey: "programId",
  tagTypes: ["GLOBO", "Programs"],
lookupMap: (item) => ({
  ...item,
  value: item.programId,
  label: item.programName,
}),
  getInvalidationTags: ({ mode, patch }) => {
    const tags = [{ type: type, id: type }];
    if (mode === "save" || mode === "delete") {
      tags.push({ type: type, id: patch.programId });
    }
    return tags;
  },
});

export const {
  useGetGloboProgramsQuery,
  useFindGloboProgramsQuery,
  useLookUpGloboProgramsMutation,
  useDeleteGloboProgramsMutation,
  useSaveGloboProgramsMutation,
  useExportGloboProgramsMutation,
} = globoProgramsAPI;
